import BaseEditor from '../BaseEditor/BaseEditor';
import { useEffect, useState } from 'react';
import useDynamicImageLoading from '../../hooks/useDynamicImageLoading';
import ShowIf from '../../components/UI/ShowIf';
import SplashScreenLoading from '../../components/SplashScreenLoading/SplashScreenLoading';
import { CARATULA_DISCO_SETTINGS } from '../../settings/CaratulaDiscoSettings';

const galleriesBasePath: any = {
  fondos: `images/fondos/`,
  texturas: `images/texturas/`,
  detalles: `images/discos/detalles/`,
  fotos: `images/discos/fotos/`,
  titulos: `images/discos/titulos/`,
};

function CaratulaDisco() {
  const selectedCategorySettings = CARATULA_DISCO_SETTINGS;
  const [settings, setSettings] = useState<any>(null);
  const [loadingImages, updatedSelectedCategorySettings] = useDynamicImageLoading(
      selectedCategorySettings,
      galleriesBasePath
  );

  useEffect(() => {
    if (loadingImages) {
      return;
    }

    setSettings(updatedSelectedCategorySettings);
  }, [loadingImages]);

  return (
    <ShowIf condition={!!settings} elseChildren={<SplashScreenLoading />}>
      <BaseEditor workArea={{ height: 1080, width: 1080 }} selectedCategorySettings={settings} />
    </ShowIf>
  );
}

export default CaratulaDisco;
